<template>
  <div class="inner-page">

    <header class="inner-page__header  inner-page__header-light">

      <div class="row  justify-content-between  align-items-center">

        <div class="inner-page__logo  col">
          <div class="exam__sidebar-logo">
            <LogoComponent/>
          </div>
        </div>
        <div class="inner-page__right">
          <div class="inner-page__lang test-language">
            <button class="language-button btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="lang-sm lang-lbl" :title="$lang.app[testingLocale]" :lang="testingLocale"></span>
            </button>
            <div v-if="$store.getters['language/getLocales'].length > 0" class="dropdown-menu">
              <a v-for="locale in $store.getters['language/getLocales']" @click="changeCandidateLocale(locale.title)" class="dropdown-item" href="javascript:void(0)">
                <span class="lang-sm lang-lbl" :lang="locale.title"> {{ $lang.app[locale.title] }}</span>
                <span class="sr-only">{{ locale.title }}</span>
              </a>
            </div>
          </div>
          <div class="page-header__user-block">
            <ul class="page-header__nav-list">
              <li class="page-header__nav-item">
                <a @click="candidateLogout($store.getters['candidate/getCandidatePin'])" class="page-header__nav-link" href="javascript:void(0)" title="Выйти из системы">
                  {{ getTranslation('logout') }}
                </a>
              </li>
            </ul>

          </div>
        </div>

      </div>
      <!-- /row -->

    </header>
    <!--~~~~~     PAGE CONTENT     ~~~~~-->
    <main class="inner-page__content  align-items-stretch  p-0">

      <div class="exam  w-100">

        <div class="exam__content  pt-4  pr-4">

          <h1 class="exam__page-title  exam__page-title--success  mb-2">{{ getTranslation('identificationSuccessMsg') }}</h1>


          <div class="row  align-items-start">

            <div v-for="testing in testingEvents" v-bind:key="testing.id" class="col-6  col-xl-4">

              <div class="exam__card">

                <div class="exam__card-title">
                  {{ getTranslation(testing.application.type.slug) }}
                  <span v-if="testing.application.resource.type.id === RESOURCE_NRK_ID || testing.application.resource.type.id===RESOURCE_REGISTER_POST_ID" class="color-main">
                                        <b>{{ testing.application.resource.resourceTitle }}</b>
                                    </span>
                  <span v-else class="color-main">
                                        <b>{{ testing.application.resource.title }}</b>
                                    </span>
                  <span v-if="testing.application.resource.postScopeText">
                                     {{ getTranslation(testing.application.resource.postScopeText) }}
                                  </span>
                </div>

                <div v-if="!testing.application.demo" class="d-flex  align-items-baseline flex-wrap">
                  <div class="exam__data-label">{{ getTranslation('office') }}</div>
                  <div class="text--bold card-post__title ml-2">{{ testing.officeTitle }}</div>
                </div>


                <div v-if="!testing.candidateEvent" class="d-flex  align-items-baseline  justify-content-between  flex-wrap  mb-4">

                  <!--  if late dont show timer  -->
                  <timer-component
                      v-if="showTimer && !testing.isLate && !testing.isPassed && testing.durationFinish > 0 && !testing.application.demo"
                      :test-id="testing.id"
                      :duration-finish="testing.durationFinish"
                      :duration-start="testing.durationStart"
                      :is-testing="false"
                      v-on:start="enableStartButton($event)"
                      v-on:eventOver="reloadCandidateInfo"
                  />

                  <!-- if passed but no attended  -->
                  <div v-if="testing.isPassed || testing.durationFinish < 1" class="d-flex  flex-wrap  pr-3">
                                        <span class="color-danger  fz-md  mr-2">
                                            <b> {{ getTranslation('noTestResult') }} </b>
                                        </span>
                  </div>

                  <div v-else-if="testing.isLate" class="d-flex  flex-wrap  pr-3">
                                        <span class="color-danger  fz-md  mr-2">
                                            <b> {{ getTranslation('lateForTesting') }} </b>
                                        </span>
                  </div>

                  <div v-else-if="enabledTest && testing.isLate" class="d-flex  flex-wrap  pr-3">
                                        <span class="color-danger  fz-md  mr-2">
                                            <b> {{ getTranslation('youAreLate', getDuration(testing.startTime, $moment().format('YYYY-MM-DD HH:mm'))) }} </b>
                                        </span>
                  </div>

                  <div v-if="!testing.application.demo" class="color-main-lighter  fz-sm  pt-2">
                    {{ momentFormatDate(testing.startTime, 'DD.MM.YYYY') }},&nbsp;
                    {{ momentFormatDate(testing.startTime, 'HH:mm') }} — {{ momentFormatDate(testing.endTime, 'HH:mm') }}
                  </div>
                </div>

                <div v-if="testing.candidateEvent">
                  <div class="d-flex  align-items-baseline  justify-content-between  flex-wrap  mb-4">
                    <div class="color-main-lighter  fz-sm">
                      {{ getTranslation('language') }}: &nbsp;
                      <span class="color-main">{{ $lang.app[testing.candidateEvent.lang] }}</span>
                    </div>
                  </div>

                  <div class="d-flex  align-items-baseline  justify-content-between  flex-wrap  mb-4">

                    <div class="d-flex  flex-wrap  pr-3">
                      <span class="color-success  fz-md  mr-2"><b>{{ getTranslation('testFinished') }}</b></span>
                      <a class="fz-md" href="javascript:void(0)" @click="$router.push({name:'candidate.results',params:{id:testing.candidateEvent.id}})">
                        {{ getTranslation('viewResults') }}
                      </a>
                    </div>

                    <div class="color-main-lighter  fz-sm  pt-2">
                      {{ momentFormatDate(testing.candidateEvent.startTime, 'DD.MM.YYYY') }},&nbsp;
                      {{ momentFormatDate(testing.candidateEvent.startTime, 'HH:mm') }} — {{ momentFormatDate(testing.candidateEvent.endTime, 'HH:mm') }}
                    </div>

                  </div>
                </div>

                <div v-if="!testing.candidateEvent && !testing.isLate" class="d-flex  align-items-baseline  justify-content-between  flex-wrap  mb-4">
                  <label class="form__label" for="lang-id" :class="{'lang-label--disabled': checkForDisabledLang(testing)}">{{ getTranslation('selectLanguage') }}</label>
                  <select  :disabled="checkForDisabledLang(testing)" :class="{'lang-label--disabled': checkForDisabledLang(testing)}" class="field  field--select  field--full-width" id="lang-id"
                          v-model="testing.lang">
                    <option :value="'ru_RU'">
                      {{ $lang.app['ru_RU'] }}
                    </option>

                    <option :value="'ky_KG'">
                      {{ $lang.app['ky_KG'] }}
                    </option>

                  </select>

                </div>


                <div v-if="!testing.candidateEvent && !testing.isLate" class="d-flex  align-items-baseline  justify-content-between  mb-4">

                  <a :disabled="checkForDisabledTimer(testing)" @click="startTest(testing)" href="javascript:void(0)" class="btn  btn--main  m-0  mt-2">
                    {{ getTranslation('startTest') }}
                  </a>

                </div>

                <button @click="openInfo(testing.id)" class="collapse-btn test-info" :class="{'collapse-btn--active':showTestInfo(testing.id)}">
                  <span class="collapse-btn__text">{{ getTranslation('aboutTesting') }}</span>

                  <span class="collapse-btn__icon-wrap">
                                        <svg class="collapse-btn__icon" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M.297.373C.733-.081 1.49-.127 1.99.27L6 3.46 10.01.27c.498-.397 1.257-.35 1.693.103.437.453.386 1.142-.113 1.539L6.79 5.73c-.452.36-1.128.36-1.58 0L.41 1.912C-.09 1.515-.14.826.297.372z">
                                            </path>
                                        </svg>
                                    </span>
                </button>

                <ol class="pl-3  pt-2" :class="{'d-none':!showTestInfo(testing.id)}">
                  <li v-for="testInfo in testing.testingInfo" class="mb-2">
                                        <span class="color-main">
                                            <b v-if="testingLocale === $lang.app.ky_locale">{{ testInfo.testType.titleKg }}:</b>
                                            <b v-else>{{ testInfo.testType.titleRu }}:</b>
                                        </span>
                    {{ getTranslation('testing_questionCount', testInfo.questionCount) }}, {{ getTranslation('testing_duration', testInfo.duration) }}, {{
                      getTranslation('testing_minimalPoint', testInfo.minimalPoint)
                    }}%;
                  </li>
                </ol>


              </div>

            </div>

          </div>

        </div>

      </div>

    </main>
    <!--~~~~~     / PAGE CONTENT     ~~~~~-->
    <Footer/>

  </div>
</template>

<script>
import AuthHeader from "./components/AuthHeader";
import Footer from "../layouts/Footer";
import testMixin from "../testing/mixins/test";
import TimerComponent from "@/components/TimerComponent";
import LogoComponent from "@/views/candidate/layouts/components/LogoComponent";

const RESOURCE_CATEGORIES_ID = 4;
const RESOURCE_EKYZMAT_ID = 1;
const RESOURCE_LOCAL_POSITIONS_ID = 2;
const RESOURCE_NRK_ID = 3;

export default {
  name: "AuthSuccess",
  components: {TimerComponent, Footer, AuthHeader, LogoComponent},
  mixins: [testMixin],
  data() {
    return {
      candidate: {
        id: null,
        pin: null,
      },
      candidateFetchCount: 0,
      RESOURCE_CATEGORIES_ID: RESOURCE_CATEGORIES_ID,
      RESOURCE_EKYZMAT_ID: RESOURCE_EKYZMAT_ID,
      RESOURCE_NRK_ID: RESOURCE_NRK_ID,
      RESOURCE_LOCAL_POSITIONS_ID: RESOURCE_LOCAL_POSITIONS_ID,
      testing: false,
      testingEvents: [],
      showTimer: false,
      timing: null,
      enabledTest: [],
      showInfo: [],

    }
  },
  updated() {
    this.setHeadings({
      title: this.getTranslation('testing')
    });
  },
  created() {
    this.getCandidateInfo();
    this.changeLocale(this.testingLocale || this.$lang.app.ru_locale, true);
  },
  methods: {
    showTestInfo(testId) {
      return this.showInfo.includes(testId);
    },

    openInfo(testId) {
      if (this.showInfo.includes(testId))
        this.showInfo = this.showInfo.filter(item => item !== testId);
      else
        this.showInfo.push(testId);

      this.$scrollTo('.test-info');
    },

    changeCandidateLocale(locale) {
      this.changeLocale(locale, true).then(() => {
        this.getCandidateInfo();
      })
    },

    reloadCandidateInfo() {
      this.loadCandidate(true)
          .then(() => {
            this.candidateFetchCount++;
            this.getCandidateInfo();
          })
    },

    getCandidateInfo() {


      this.candidate = this.$store.getters['candidate/getCandidate'];

      let testing = this.$store.getters['candidate/hasActiveTesting'];

      if (!testing) {

        this.testingEvents = this.$store.getters['candidate/getEvents'].map(item => {
          if (item.application.resource.type.id === RESOURCE_LOCAL_POSITIONS_ID)
            item.resourceTitle = item.application.resource.positionName;

          if (item.isBishkek)
            item.lang = 'ru_RU';
          else
            item.lang = 'ky_KG'
          return item;
        });
      } else {
        let currentEvent = this.$store.getters['candidate/getCurrentEvent'];

        let found = false;
        for (let te of this.testingEvents) {
          if (te.id === currentEvent.id) {
            found = true;
            break;
          }
        }
        if (!found)
          this.testingEvents.push(this.$store.getters['candidate/getCurrentEvent']);

        return this.$router.push({name: 'candidate.test'}).catch(() => {
        })
      }

      for (let item of this.testingEvents)
        if (!item.candidateEvent && !item.isLate && !this.showInfo.includes(item.id))
          this.showInfo.push(item.id);

      this.showTimer = true;

      this.testing = testing;

    },

    enableStartButton($event) {
      //testEvent id collection
      this.enabledTest.push($event);
    },

    checkForDisabledTimer(testEvent) {

      if (testEvent.isLate || testEvent.isPassed)
        return true;

      if (testEvent.durationFinish < 1)
        return true;

      if (testEvent.isActive)
        return false;

      if (this.enabledTest.indexOf(testEvent.id) > -1) {
        if (this.candidateFetchCount < this.testingEvents.length) {
          this.reloadCandidateInfo();
        }
        return false;
      }

      return testEvent.durationStart > 0;
    },

    checkForDisabledLang(testEvent) {

      if (testEvent.durationFinish < 1)
        return true;

      if (this.enabledTest.indexOf(testEvent.id) > -1)
        return false;


      return !testEvent.isActive;

    },

    startTest(test) {
      this.axios.post(this.$config.urls.candidateTesting.startTesting.url, {
        eventId: test.id,
        lang: test.lang,
        accessToken: this.getAccessToken()
      }).then(async response => {

        //active testing event
        await this.$store.dispatch('candidate/setCurrentEvent', response.data.data.currentEvent);

        // current test
        await this.$store.dispatch('candidate/setCurrentTesting', response.data.data.candidateTest);

        //candidateEvent
        await this.$store.dispatch('candidate/setActiveEvent', response.data.data.activeEvent);

        await this.changeLocale(test.lang, true);

        //testing boolean
        await this.$store.dispatch('candidate/setActiveTesting', response.data.data.testing).then(() => {
          this.$router.push({name: 'candidate.test', query: {question: '1'}}).catch(() => {
          });
        });

      });
    },
  }
}
</script>

<style scoped>
.exam__timer {
  font-size: 26px;
}

.lang-label--disabled {
  color: #4e555b !important;
  opacity: 0.5 !important;
}
</style>
